module.exports = __webpack_public_path__ + "img/-e-location_js@2x.00e8ff8d.png";